<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.machineId" :getMethod="getMachineById"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]" :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewMachineContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.Machine
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.machineId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.MachineChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>